import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchApptsStart } from '../redux/Appointments/appts.actions';
import { updateUserStart, fetchCustomersStart } from '../redux/User/user.actions';

import { Container } from 'react-bootstrap'
import { GoogleMap, LoadScript, Marker, InfoWindow  } from '@react-google-maps/api';

import Geocode from "react-geocode";
Geocode.setApiKey(process.env.REACT_APP_GEOCODE_KEY);

const mapState = ({ user }) => ({
	customers: user.customers,
	currentUser: user.currentUser,
})



const VendorMapDetails = () => {
	
	const {  customers, currentUser } = useSelector(mapState);
	const dispatch = useDispatch();
	const [ selected, setSelected ] = useState({});

	const [displayName] = useState(currentUser.displayName);
	const [address] = useState(currentUser.address);
	const [address2] = useState(currentUser.address2);
	const [city] = useState(currentUser.city);
	const [state] = useState(currentUser.state);
	const [zip] = useState(currentUser.zip);
	const [phone] = useState(currentUser.phone);
	const [subscribed] = useState(currentUser.subscribed);
	let [fullAddress] = useState(currentUser.fullAddress);
	const [center, setCenter] = useState(currentUser.center);
	const [EIN] = useState(currentUser.EIN)
	const [contactName] = useState(currentUser.contactName)
	const [contactEmail] = useState(currentUser.contactEmail)
  
	const onSelect = item => {
		setSelected(item);
	}

	const { customersData } = customers;

	useEffect(() => {
		if(currentUser.center === 0){
			Geocode.fromAddress(currentUser.fullAddress).then(
				response =>
					{ 
						setCenter(response.results[0].geometry.location);
					}
			);
			dispatch(updateUserStart({
				EIN,
				contactName,
				contactEmail,
				displayName,
				address,
				address2,
				city,
				state,
				zip,
				phone,
				subscribed,
				fullAddress,
				center
				
			}))
		}
		// eslint-disable-next-line
	}, [currentUser]);  
	
	useEffect(() => {
		dispatch(
			fetchApptsStart()
		);
		dispatch(
			fetchCustomersStart()
		);
		window.scrollTo(0, 0)
		// eslint-disable-next-line
	}, []); 
	
	//only show subscribed customers
	let subscribedCustomers = []
	if(Array.isArray(customersData)){
		subscribedCustomers = customersData.filter(function (e) {
			return e.subscribed
		})

	}

	const custAdd = [];
	if(Array.isArray(customersData)){
		for(let i = 0; i < customersData.length; i++){
			
			custAdd.push(customersData[i].fullAddress)
			
		}
	}


	const mapStyles = {        
		height: "80vh",
		width: "80%"
	}
	  
	// const locations =  [

	// 	{
	// 	  	name: currentUser.displayName,
	// 	  	info: currentUser.fullAddress,
	// 		phone: currentUser.phone ,
	// 	  	location: center
	// 	},
	// 	{
	// 		name: 'currentUser.displayName',
	// 		info: 'currentUser.fullAddress',
	// 	  phone: 'currentUser.phone ',
	// 		location: {
	// 			lat:41.0695767,
	// 			lng:-111.9912803
	// 		}
	//   }

	// ]

	// console.log(subscribedCustomers)
	
	


	


	
	  
	return (
		
		<Container className="text-center flex justify-content-center" >
		<LoadScript googleMapsApiKey={process.env.REACT_APP_GEOCODE_KEY}>
			<GoogleMap
				mapContainerStyle={mapStyles}
				zoom={8}
				center={center}
			>

				{
					subscribedCustomers.map(item => {
					return (
					<Marker key={item.displayName} 
						position={item.center}
						onClick={() => onSelect(item)}
					/>
					)
					})
				}
				{
					selected.center && 
					(
					<InfoWindow
					position={selected.center}
					clickable={true}
					onCloseClick={() => setSelected({})}
					>
						<div>
							<h5>{selected.displayName}</h5>
							<p>{selected.fullAddress}</p>
					
							<button className="btn" onClick={() => window.open(`tel:${selected.phone}`)}>Call</button>
						</div>
					</InfoWindow>
					)
				}
			</GoogleMap>
		</LoadScript>

		</Container>
	)
}
export default VendorMapDetails;






